import React, { CSSProperties } from "react";
import { MoreVert, MoreHoriz } from "@mui/icons-material";
import { IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { BoxProps } from "@mui/material/Box/Box";

export interface MenuOption {
  title: string;
  onClick: () => void;
  color?: string;
  Icon?: React.FC<BoxProps>;
  disabled?: boolean;
  style?: CSSProperties;
}

export interface OptionButtonProps {
  options?: MenuOption[];
  disabled?: boolean;
  vertical?: boolean;
}

const OptionButton: React.FC<OptionButtonProps> = ({
  options,
  disabled,
  vertical = true,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={handleClick} disabled={disabled}>
        {vertical ? <MoreVert /> : <MoreHoriz />}
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {options?.map(
          ({ title, onClick, color, Icon, disabled, style = {} }) => (
            <MenuItem
              key={title}
              disabled={disabled}
              style={{ paddingLeft: 24, paddingRight: 24, ...style }}
              onClick={(event) => {
                event.stopPropagation();
                handleClose(event);
                onClick();
              }}
            >
              <div style={{ color, display: "flex", alignItems: "center" }}>
                {Icon ? (
                  <Icon style={{ marginRight: 5, width: 16, height: 16 }} />
                ) : null}
                {title}
              </div>
            </MenuItem>
          )
        )}
      </Menu>
    </>
  );
};

export default OptionButton;
